import { Container } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux'

import Products from '../Products/Products'
import Search from '../Search/SearchBar'
import { getProducts } from '../../actions/productActions'

const Home = () => {
    const dispatch = useDispatch()

    useEffect(()=> {
        dispatch(getProducts())
    }, [dispatch])
    
    return ( 
        <Container>
            <Search />
            <Products />
        </Container>
    );
}
 
export default Home;